import React, { Component } from "react";
import Article from "../shared/Article";
import Store from "../../content/Store";
import ShadowedContainer from "../shared/containers/ShadowedContainer";
import SummaryDetail from "../shared/groups/SummaryDetail";
import SummaryDetailRow from "../shared/groups/SummaryDetailRow";
import { connect } from "react-redux";
import Contentify from "../../content/Contentify";
import DateHelper from "../../helpers/DateHelper";
import HelpSection from "../shared/HelpSection";
import Content from "../../content/Content";
import { getRenewalDocuments } from "../../actions/cover/CoverActions";
import { mapStateToProps as mapStateDocumentHelper } from "../../helpers/cover/CoverDocumentHelper";
import FileDownloadList from "./../download/FileDownloadList";
import InfoBox from "../shared/InfoBox";
import { Paths } from "../../constants/UrlConstants";
import { Redirect } from "react-router-dom";

export const mapStateToRenewal = (state) => {
  let documentState = mapStateDocumentHelper(state);

  let policy =
    state && state.policyReducer && state.policyReducer.selectedPolicy;

  return {
    ...documentState,
    RenewalDate: policy.RenewalDate,
    ShowRenewalInformation: policy.ShowRenewalInformation,
    ShouldShowFourthTermShopAroundWording:
      policy.ShouldShowFourthTermShopAroundWording,
    ShouldShowFormat2MigrationWording: policy.ShouldShowFormat2MigrationWording,
    ShouldShowDiscountWording: policy.ShouldShowDiscountWording,
    ShouldShowDoubleExcessWording: policy.ShouldShowDoubleExcessWording,
    RenewalPremium: policy.RenewalPremium,
    LastYearMonthlyPremium: policy.LastYearMonthlyPremium,
    LastYearTotalAnnualPremium: policy.LastYearTotalAnnualPremium,
    IsPreviousYearsPremiumPresent: policy.IsPreviousYearsPremiumPresent
  };
};
export class Renewal extends Component {
  static content = Store.Renewal;

  constructor(props) {
    super(props);

    if (
      this.props.membershipNumber &&
      (this.props.RenewalMembershipStatement === undefined ||
        (this.props.RenewalMembershipStatement === null &&
          !this.props.isDependant))
    ) {
      this.props.getRenewalDocuments(this.props.membershipNumber);
    }
  }

  render() {
    return this.props.ShowRenewalInformation ? (
      <ShadowedContainer>
        <Article header={Store.Renewal.Heading} />
        <div className={"row my-4"}>
          <div className="col-lg-6">
            <SummaryDetail>
              <SummaryDetailRow
                title={this.props.content.RenewalDate}
                value={DateHelper.getDateInStringFormat(this.props.RenewalDate)}
              />
              {!this.props.HideCoverDetails && (
                <SummaryDetailRow
                  title={this.props.content.RenewalPremium}
                  value={
                    this.props.RenewalPremium +
                    " (" +
                    this.props.content.RenewalFrequency +
                    ")"
                  }
                />
              )}
            </SummaryDetail>
          </div>
        </div>
        <div className={"row my-4"}>
          <div className="col-12">
            <h3>{this.props.content.DocumentsHeading}</h3>
            {this.props.content.DocumentsDescription}
            {this.props.renewalMembershipStatementMissing && (
              <InfoBox
                iconClass={"icon-functional-help"}
                children={this.props.content.RenewalMembershipStatementMissing}
                className="my-4"
              />
            )}
            {this.props.isDependant && (
              <InfoBox
                iconClass={"icon-functional-help"}
                children={
                  this.props.content.DependantRenewalMembershipStatementMessage
                }
                className="my-4"
              />
            )}
            {this.props.renewalDocumentList &&
            this.props.renewalDocumentList.length > 0 ? (
              <FileDownloadList files={this.props.renewalDocumentList} />
            ) : null}
          </div>
          <div className="col-12 mt-4">
            {this.props.content.PleaseNoteDescription}
          </div>
        </div>

        <div className={"row my-4"}>
          <div className="col-12">
            {this.props.content.ContactUsDescription}
          </div>
        </div>
        {this.props.IsPreviousYearsPremiumPresent && (
          <div className={"row mt-4"}>
            <div className="col-12">
              <h3>{this.props.content.HowMuchCoverLastYearHeading}</h3>

              <Content
                name={Store.Renewal.HowMuchCoverLastYearDescription}
                params={{
                  LastYearTotalAnnualPremium: this.props
                    .LastYearTotalAnnualPremium
                }}
              />

              {this.props.ShouldShowDiscountWording
                ? this.props.ShouldShowFormat2MigrationWording
                  ? this.props.content
                      .ShopAroundContentForFormat2MigrationDiscount
                  : this.props.ShouldShowFourthTermShopAroundWording
                  ? this.props.content
                      .ShopAroundContentForFourthRenewalFCADiscount
                  : this.props.content
                      .ShopAroundContentForPreFourthRenewalFCADiscount
                : this.props.ShouldShowFormat2MigrationWording
                ? this.props.content.ShopAroundContentForFormat2Migration
                : this.props.ShouldShowFourthTermShopAroundWording
                ? this.props.content.ShopAroundContentForFourthRenewalFCA
                : this.props.content.ShopAroundContentForPreFourthRenewalFCA}
            </div>
          </div>
        )}
        <div className="mt-4">
          <HelpSection
            HeadingLinkText={Store.Renewal.HelpSection.HeadingLinkText}
            HeadingLinkTo={Store.Renewal.HelpSection.HeadingLinkTo}
            MoreHelpLinkText={Store.Renewal.HelpSection.MoreHelpLinkText}
            MoreHelpLinkTo={Store.Renewal.HelpSection.MoreHelpLinkTo}
            HelpSet={Store.Renewal.HelpSection.HelpSet}
          />
        </div>
      </ShadowedContainer>
    ) : (
      <Redirect to={Paths.NotFound} />
    );
  }
}

export default connect(mapStateToRenewal, { getRenewalDocuments })(
  Contentify(Renewal)
);
